import * as Constants from '../constants/';

export default function(state = {}, action) {
  switch (action.type) {
    case Constants.UPDATE_FORM:
      return {
        ...state,
        [action.form]: {
          ...state[action.form],
          ...action.data
        }
      };
    default:
      return state;
  }
}
